import { useState, useEffect, useCallback, useRef } from 'react';

const HubSpotChat = (portalId) => {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [activeConversation, setActiveConversation] = useState(false);
    const eventRef = useRef(null);

    useEffect(() => {
        window.hsConversationsSettings = {
            loadImmediately: false,
        };

        // Create script component if there is portalId
        if (portalId !== "") {
            let script = document.createElement('script');
            script.src = `//js.hs-scripts.com/${portalId}.js`;
            script.async = true;

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
                window.hsConversationsOnReady = [];
            }
        }

    }, [portalId]);

    // Subscripe to conversation events.
    useEffect(() => {
        eventRef.current = (payload) => {
            setActiveConversation(payload.conversation.conversationId);
        }

        if (hasLoaded && window.HubSpotConversations?.on) {
            window.HubSpotConversations.on('conversationStarted', eventRef.current);
        }

        return () => {
            if (portalId !== "" && window.HubSpotConversations?.off) {
                window.HubSpotConversations.off('conversationStarted', eventRef.current);
            }
        }

    }, [hasLoaded, portalId]);

    const openHandler = useCallback(() => {
        window.hsConversationsOnReady = [() => {
        }];
        setHasLoaded(true);
        if (window.HubSpotConversations?.widget) {
            window.HubSpotConversations.widget.load();
            window.HubSpotConversations.widget.open();
        }
    }, []);

    const closeHandler = useCallback(() => {
        setHasLoaded(false);
        if (window.HubSpotConversations?.widget) {
            window.HubSpotConversations.widget.remove();
        }
    }, [])

    return {
        hasLoaded,
        activeConversation,
        openHandler,
        closeHandler
    };
}

export default HubSpotChat;